import { render, staticRenderFns } from "./QuestionsSection.vue?vue&type=template&id=aa55f6b2&"
import script from "./QuestionsSection.vue?vue&type=script&lang=js&"
export * from "./QuestionsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\marci\\Desktop\\majorel-china-static\\www\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa55f6b2')) {
      api.createRecord('aa55f6b2', component.options)
    } else {
      api.reload('aa55f6b2', component.options)
    }
    module.hot.accept("./QuestionsSection.vue?vue&type=template&id=aa55f6b2&", function () {
      api.rerender('aa55f6b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/templates/QuestionsSection.vue"
export default component.exports